import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[AssetType SetFilter] Action',
  ResetFilter: '[AssetType ResetFilter] Action',
}

const initialAssetTypeState: IAssetTypeState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IAssetTypeState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-AssetType', whitelist: ['filter']},
  (state: IAssetTypeState = initialAssetTypeState, action: ActionWithPayload<IAssetTypeState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialAssetTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
